var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoaded),expression:"isLoaded"}],class:'avatar avatar--'+_vm.size,attrs:{"src":_vm.imgUrl,"alt":_vm.user.name},on:{"load":function($event){_vm.isLoaded = true},"error":function($event){return _vm.setDefaultImage($event)},"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }